'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
	var siteName = 'default-package';
	var htmlHasClass = function htmlHasClass(_class) {
		return document.documentElement.classList.contains(_class);
	};
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 60
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test\\.' + siteName + '\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			// ローカル環境ならincludeをAjaxで読み込む
			var _this = this;
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');

			includeClass.forEach(function (ele) {
				var path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(function (ele) {
					var xhr = new XMLHttpRequest();
					var promise = new Promise(function (resolve, reject) {
						xhr.onreadystatechange = function () {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(function (results) {
					var regExp = new RegExp(key);

					results.forEach(function (ele) {
						var classList = ele.split(/ |\"/g);
						var position = void 0;

						classList.forEach(function (ele2) {
							if (ele2.match(regExp)) {
								position = ele2;
							}
						});
						document.querySelectorAll('.' + position).forEach(function (ele2) {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch(function (error) {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(function (ele) {
				hash = ele.split('=');
				hash[1] = hash[1].indexOf('#') !== -1 ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		accordion: function accordion() {
			var details = document.querySelectorAll('.js-accordion');

			details.forEach(function (ele) {
				var summary = ele.querySelector('summary');
				var wrapper = ele.querySelector('.mod-accordion-wrapper');
				var plus = ele.querySelector('.mod-accordion-plus');
				summary.addEventListener('click', function (e) {
					e.preventDefault();
					if (ele.open) {
						var close = wrapper.animate({
							opacity: [1, 0],
							height: [wrapper.offsetHeight + 'px', 0]
						}, {
							duration: 300,
							easing: 'ease'
						});
						plus.animate({ rotate: ['90deg', '0deg'] }, {
							duration: 300,
							pseudoElement: "::after",
							easing: 'ease',
							fill: 'forwards'
						});
						close.onfinish = function () {
							ele.removeAttribute('open');
						};
					} else {
						ele.setAttribute('open', 'true');
						wrapper.animate({
							opacity: [0, 1],
							height: [0, wrapper.offsetHeight + 'px']
						}, {
							duration: 300,
							easing: 'ease'
						});
						plus.animate({ rotate: ['0deg', '90deg'] }, {
							duration: 300,
							pseudoElement: "::after",
							easing: 'ease',
							fill: 'forwards'
						});
					}
				});
			});
		},
		tabSwitch: function tabSwitch() {
			var $tab = document.querySelectorAll('.js-tab');
			var $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					var hash = location.hash.split('#')[1];
					$tab.forEach(function (ele) {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach(function (ele) {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(function () {
								ele.classList.add(v);
							}, 200);
						}
					});
				}

				$tab.forEach(function (ele) {
					ele.addEventListener('click', function () {
						$tab.forEach(function (ele2) {
							ele2.classList.remove(a);
						});
						ele.classList.add(a);
						$content.forEach(function (ele) {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						var $target = void 0;
						var target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(function (ele) {
							ele.classList.add(a);
							setTimeout(function () {
								ele.classList.add(v);
							}, 200);
						});
					});
				});
			}
		},
		easeScroll: function easeScroll() {
			var _this2 = this;

			var scrollToObject = function scrollToObject(_self) {
				var hash = _self.currentTarget.href.split('#')[1];
				var pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				var offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
						pos = pos - FUNCTIONS.va.header.sp;
					} else {
						pos = pos - FUNCTIONS.va.header.desktop;
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			};
			// フォーカス用関数
			var scrollFocus = function scrollFocus(_hash) {
				var hash = _hash;
				if (hash !== 'pagetop') {
					var focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
					var focusableElements = Array.from(document.getElementById(hash).querySelectorAll(focusableElementsSelector));
					if (focusableElements.length) {
						focusableElements[0].focus({ preventScroll: true });
					}
				}
			};
			// スクロール完了後に実行する関数
			var scrollResolveTimeout = void 0;
			var waitForScrollComplete = function waitForScrollComplete(_hash) {
				return new Promise(function (resolve) {
					var scrollTimeout = setTimeout(function () {
						resolve(true);
					}, 100);
					var scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				});
			};
			document.querySelectorAll('a[rel="scroll"]').forEach(function (ele) {
				ele.addEventListener('click', function () {
					var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
						var hash;
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										e.preventDefault();

										if (!/#/.test(e.currentTarget.href)) {
											_context.next = 7;
											break;
										}

										scrollToObject(e);
										hash = e.currentTarget.href.split('#')[1];
										_context.next = 6;
										return waitForScrollComplete(hash);

									case 6:
										return _context.abrupt('return', false);

									case 7:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this2);
					}));

					return function (_x) {
						return _ref.apply(this, arguments);
					};
				}());
			});
		},
		easeScrollHash: function easeScrollHash() {
			var _this3 = this;

			var hash = location.hash;
			if (hash) {
				// フォーカス用関数
				var scrollFocus = function scrollFocus(_hash) {
					var hash = _hash;
					if (hash !== 'pagetop') {
						var focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						var focusableElements = Array.from(document.getElementById(hash).querySelectorAll(focusableElementsSelector));
						if (focusableElements.length) {
							focusableElements[0].focus();
						}
					}
				};
				// スクロール完了後に実行する関数
				var scrollResolveTimeout = void 0;
				var waitForScrollComplete = function waitForScrollComplete(_hash) {
					return new Promise(function (resolve) {
						var scrollTimeout = setTimeout(function () {
							resolve(true);
						}, 100);
						var scrollTimeoutEvent = addEventListener('scroll', function fn(e) {
							clearTimeout(scrollTimeout);
							clearTimeout(scrollResolveTimeout);
							scrollResolveTimeout = setTimeout(function () {
								scrollFocus(_hash);
								removeEventListener('scroll', fn);
								resolve(true);
							}, 100);
						});
					});
				};
				window.addEventListener('load', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
					return regeneratorRuntime.wrap(function _callee2$(_context2) {
						while (1) {
							switch (_context2.prev = _context2.next) {
								case 0:
									document.documentElement.style.display = 'none';
									document.body.style.display = 'none';

									setTimeout(function () {
										document.documentElement.style.display = 'block';
										document.body.style.display = 'block';

										var pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

										if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
											pos -= FUNCTIONS.va.header.sp;
										} else {
											pos -= FUNCTIONS.va.header.desktop;
										}
										window.scrollTo({ top: pos, behavior: 'smooth' });
									}, 100);
									_context2.next = 5;
									return waitForScrollComplete(hash);

								case 5:
								case 'end':
									return _context2.stop();
							}
						}
					}, _callee2, _this3);
				})));
			}
		},
		pageTop: function pageTop() {
			var footer = document.querySelector('.footer');
			var $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				window.addEventListener('scroll', function (e) {
					if (window.scrollY > '100') {
						$pagetop.classList.add(v);
					} else {
						$pagetop.classList.remove(v);
					}
				});
			}
		},
		setModal: function setModal() {
			var createModal = function createModal(_appendHTML, _target) {
				var $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(function () {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach(function (ele) {
						ele.addEventListener('click', function (e) {
							$container.classList.remove(v);
							setTimeout(function () {
								$container.classList.remove(a);
								$container.remove();
								_target.focus();
							}, 400);
						});
					});
					window.addEventListener("keydown", function (event) {
						if (document.querySelectorAll('.mod-modal-overlay').length) {
							// タブキーが押された時
							if (event.key === "Tab") {
								event.preventDefault();
								// モーダル要素内のフォーカス可能な要素の一覧を取得
								var focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
								var focusableElements = Array.from(document.querySelector('.mod-modal-overlay').querySelectorAll(focusableElementsSelector));
								// 現在のフォーカス位置を取得
								var focusedItemIndex = focusableElements.indexOf(document.activeElement);
								// shiftキーと同時に押されてた場合
								if (event.shiftKey) {
									if (focusedItemIndex === 0) {
										// 現在のフォーカスが最初の要素の場合、最後の要素にフォーカスを移動
										focusableElements[focusableElements.length - 1].focus();
									} else {
										// 現在のフォーカスが最初の要素以外の場合、前の要素にフォーカスを移動
										focusableElements[focusedItemIndex - 1].focus();
									}
								} else {
									if (focusedItemIndex === focusableElements.length - 1) {
										// 現在のフォーカスが最後の要素の場合、最初の要素にフォーカスを移動
										focusableElements[0].focus();
									} else {
										// 現在のフォーカスが最後の要素以外の場合、次の要素にフォーカスを移動
										focusableElements[focusedItemIndex + 1].focus();
									}
								}
							}
							// ESCキーが押された時
							if (event.key === "Escape") {
								event.preventDefault();
								$container.classList.remove(v);
								setTimeout(function () {
									$container.classList.remove(a);
									$container.remove();
									_target.focus();
								}, 400);
							}
						}
					});
				});
			};
			document.querySelectorAll('.mod-modal').forEach(function (ele) {
				ele.addEventListener('click', function (e) {
					var targetKey = e.currentTarget.getAttribute('data-target');
					var $content = document.querySelector('.mod-modalContent[data-target="' + targetKey + '"]');
					if ($content) {
						var closeButton = document.createElement('button');
						closeButton.setAttribute('type', 'button');
						closeButton.className = 'mod-modal-closeBtn';
						closeButton.setAttribute('aria-label', 'close');
						closeButton.innerHTML = '<span aria-hidden="true"></span>';

						$content.appendChild(closeButton);

						var closeArea = document.createElement('div');
						closeArea.className = 'mod-modal-closeArea';
						var containerDiv = document.createElement('div');
						containerDiv.appendChild(closeArea);
						containerDiv.appendChild($content.cloneNode(true));

						createModal(containerDiv.innerHTML, e.currentTarget);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach(function (ele) {
				ele.addEventListener('click', function (e) {
					var appendHTML = '<div class="mod-modal-closeArea"></div>\n\t\t\t\t\t\t<button type="button" class="mod-modal-closeBtn" aria-label="close"><span aria-hidden="true"></span></button>\n\t\t\t\t\t\t' + e.currentTarget.querySelector('img').outerHTML;
					createModal(appendHTML, e.currentTarget);
					return false;
				});
			});
		},
		matchHeight: function matchHeight() {
			var $elements = document.querySelectorAll('[data-mh]');
			var groups = new Map();

			$elements.forEach(function (ele) {
				ele.style.height = 'auto';
			}); // 初期化

			$elements.forEach(function (ele) {
				var attributeName = ele.getAttribute('data-mh');
				if (!groups.has(attributeName)) {
					groups.set(attributeName, []);
				}
				groups.get(attributeName).push(ele);
			});
			groups.forEach(function (group) {
				var attributeGroups = new Map();
				group.forEach(function (ele) {
					var attributeName = ele.getAttribute('data-mh');
					var topPosition = ele.getBoundingClientRect().top;
					var key = attributeName + '_' + topPosition;
					if (!attributeGroups.has(key)) {
						attributeGroups.set(key, []);
					}
					attributeGroups.get(key).push(ele);
				});
				attributeGroups.forEach(function (item) {
					var maxHeight = Math.max.apply(Math, _toConsumableArray(item.map(function (ele) {
						return ele.offsetHeight;
					})));
					item.forEach(function (ele2) {
						ele2.style.height = maxHeight + 'px';
					});
				});
			});
		},
		inViewAnimation: function inViewAnimation() {
			var target = document.querySelectorAll('.js-fade');
			var options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			var callback = function callback(entries, observer) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			var observer = new IntersectionObserver(callback, options);

			target.forEach(function (ele) {
				observer.observe(ele);
			});
		},
		headerHamburger: function headerHamburger() {
			var $hamburger = document.querySelector('.header-hamburger');
			var $nav = document.querySelector('.header-nav');
			var $container = document.querySelector('.container');
			var scrollTopNow = void 0;

			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = window.scrollY;
				$container.style.position = 'fixed';
				$container.style.width = '100%';
				$container.style.top = -1 * scrollTopNow;
				$container.style.left = 0;
				document.body.classList.add(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				$container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo({ top: scrollTopNow });
			};

			if ($hamburger) {
				$hamburger.addEventListener('click', function (e) {
					e.currentTarget.classList.toggle(a);
					if ($nav.classList.contains(a)) {
						$nav.classList.remove(v);
						$nav.classList.remove(a);
						fixedOffContainer();
					} else {
						fixedOnContainer();
						$nav.classList.add(a);
						setTimeout(function () {
							$nav.classList.add(v);
						});
					}
				});
			}
		},
		fileSize: function fileSize() {
			var bytesToSize = function bytesToSize(bytes) {
				var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) {
					return 'n/a';
				}
				var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
				if (i === 0) {
					return bytes + ' ' + sizes[i];
				}
				return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
			};
			if (document.querySelectorAll('.js-fileSize').length) {
				document.querySelectorAll('.js-fileSize').forEach(function (pdfElement) {
					pdfElement.innerText = bytesToSize(pdfElement.innerText);
				});
			}
		},
		removeElmIfEmpty: function removeElmIfEmpty() {
			// ＜ルート設定対応＞要素が空だったら削除
			var $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(function (ele) {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty: function removeBlockIfListEmpty() {
			// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
			var $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(function (ele) {
					if (!ele.getElementsByTagName('li')) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		headerMenu: function headerMenu() {
			var overlay = document.querySelector('.header-menu-overlay');
			var scrollTopNow = void 0;

			// <SP/TABLET>ヘッダーメニュー開閉
			if (document.querySelector('.header-menuBtn')) {
				var menu = document.querySelector('.header-menu');
				document.querySelector('.header-menuBtn').addEventListener('click', function (e) {
					var menuBtn = document.querySelector('.header-menuBtn');

					menuBtn.classList.toggle(a);
					if (menuBtn.classList.contains(a)) {
						// 開く
						menu.classList.add(a);
						fixedOnContainer();
					} else {
						// 閉じる
						menu.classList.remove(a);
						fixedOffContainer();
					}
				});

				overlay.addEventListener('click', function (e) {
					menu.classList.remove(a);
					document.querySelector('.header-menuBtn').classList.remove(a);
					fixedOffContainer();
				});
			}
			var fixedOnContainer = function fixedOnContainer() {
				scrollTopNow = window.scrollY;
				var container = document.querySelector('.container');
				container.style.position = 'fixed';
				container.style.width = '100%';
				container.style.top = -1 * scrollTopNow + 'px';
				container.style.left = '0';
				document.body.classList.add(f);
			};
			var fixedOffContainer = function fixedOffContainer() {
				var container = document.querySelector('.container');
				container.style.position = 'static';
				document.body.classList.remove(f);
				window.scrollTo(0, scrollTopNow);
			};
			document.querySelectorAll('.js-current').forEach(function (ele, idx) {
				var href = ele.getAttribute('href');
				if (location.pathname.indexOf(href) !== -1) {
					ele.classList.add(a);
					if (location.pathname !== '/' && location.pathname !== '/index.html') {
						document.querySelector('.js-current[href="/"]').classList.remove(a);
					}
				}
			});
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.accordion();
			_this.tabSwitch();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.setModal();
			_this.matchHeight();
			_this.inViewAnimation();
			_this.headerHamburger();
			_this.fileSize();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();
			_this.headerMenu();

			var resizeTime = 0;
			window.addEventListener('resize', function () {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(function () {
					_this.matchHeight();
				}, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', function () {
		return FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript();
	});
})();